import { render, staticRenderFns } from "./DirectorioEce.vue?vue&type=template&id=1b29a2df&scoped=true"
import script from "./DirectorioEce.vue?vue&type=script&lang=js"
export * from "./DirectorioEce.vue?vue&type=script&lang=js"
import style0 from "./DirectorioEce.vue?vue&type=style&index=0&id=1b29a2df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29a2df",
  null
  
)

export default component.exports